import styled from "styled-components";
import { calcRem } from "styles/theme";
import { FLEX } from "styles/flex";
import { CloseButton as ModalCloseButton } from "components/blocks/modalheader/ModalHeaderStyled";
import { SUBSCRIPTION_STATUS } from "api/interfaces/subscription.interface";

const getWarningBarColor = ({
  theme,
  $variant,
}: {
  theme: any;
  $variant: SUBSCRIPTION_STATUS;
}) => {
  if ($variant === SUBSCRIPTION_STATUS.EXPIRED_END) {
    if (theme.value === "light") {
      return theme.COLORS.ORANGE;
    }
    return theme.COLORS.VALIDATERED;
  }

  return theme.COLORS.WARNING;
};

export const Wrapper = styled.div<{ $variant: SUBSCRIPTION_STATUS }>`
  ${FLEX.FlexStartCenter};
  gap: 10px;
  width: 100%;
  flex-direction: column;
  padding: 20px;
  color: ${({ theme }) => theme.COLORS.WHITE}99;
  position: relative;
  border-radius: 12px;
  border: 1px solid ${(props) => getWarningBarColor(props)};
  background-color: ${(props) => `${getWarningBarColor(props)}35`};
  margin-top: 10px;
`;

export const Title = styled.h3<{ $variant: SUBSCRIPTION_STATUS }>`
  ${FLEX.FlexStartCenter};
  gap: 10px;
  width: 100%;
  font-weight: 500;
  color: ${(props) => getWarningBarColor(props)};
`;

export const List = styled.ul`
  width: 100%;
  padding-left: 24px;
  list-style: disc;
  list-style-position: outside;
  font-size: ${calcRem(14)};
  ${FLEX.FlexStartStart};
  gap: 4px;
  flex-direction: column;
`;

export const Item = styled.li`
  list-style: disc;
  line-height: 1.5;
`;

export const CloseButton = styled(ModalCloseButton)`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
`;
